module.exports = __webpack_public_path__ + "img/5-4.133d9399.png";